import React from "react";

export interface NumberInputSpinnerProps {
  value: number;
  onDecrement?: () => boolean;
  onIncrement?: () => boolean;
  decrementLimit?: number;
  incrementLimit?: number;
  onChangeInput?: (val: number) => void;
  containerStyle?: React.CSSProperties;
}
